module.exports = __webpack_public_path__ + "static/media/audi.3a7ea516.svg";